import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { getCareAppUserForPatientQueries } from './patientService';

/**
 * Users visible in Care app pickers / lists: same `tenantId` as the signed-in user, or all users for `superuser`.
 */
export async function getUsersForCareAppList() {
  const u = await getCareAppUserForPatientQueries();
  if (!u) return [];
  if (u.role === 'superuser' && !u.impersonatingTenantId) {
    const snap = await getDocs(collection(db, 'users'));
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  }
  const tid = u.role === 'superuser' && u.impersonatingTenantId ? u.impersonatingTenantId : u.tenantId;
  if (!tid) return [];
  const snap = await getDocs(query(collection(db, 'users'), where('tenantId', '==', tid)));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
